import ContentLoader from 'react-content-loader';
import { type GiftContentSkeletonProps } from './gift-content-skeleton.types';
import styles from './gift-content-skeleton.module.css';
import { useCallback, useMemo, type FC } from 'react';
import { GiftItemSkeleton } from '../gift-item-skeleton/gift-item-skeleton';
import { cn } from '../../utils/cn';

export const GiftContentSkeleton: FC<GiftContentSkeletonProps> = ({
    width = 318,
    height = 49,
    totalItems = 2,
    containerClassName,
}) => {
    const data = useMemo(() => {
        const padding = 10;
        const radius = 12;

        const radioSize = 14;
        const titleX = padding + radioSize;

        const titleHeight = 14;
        const titleWidth = width - padding;

        const titleY = padding + titleHeight / 2;
        return { radius, radioSize, titleX, titleHeight, titleWidth, titleY };
    }, [width]);
    const { radius, radioSize, titleX, titleHeight, titleWidth, titleY } = data;

    const renderGiftWidgetContent = useCallback(
        (index: number) => {
            return (
                <div key={index} className={styles.contentContainer}>
                    <ContentLoader
                        speed={2}
                        className={cn(styles.headerContent, containerClassName)}
                        viewBox={`0 0 ${width} ${height}`}
                    >
                        <rect x="0" y={0} rx={radius} ry={radius} width={radioSize} height={radioSize} />
                        <rect x={titleX} y={0} rx={0} ry={0} width={titleWidth} height={titleHeight} />
                        <rect x={0} y={titleY} rx={0} ry={0} width={titleWidth} height={titleHeight} />
                    </ContentLoader>
                    <GiftItemSkeleton width={240} />
                </div>
            );
        },
        [containerClassName, height, radioSize, radius, titleHeight, titleWidth, titleX, titleY, width]
    );

    return (
        <div className={styles.container}>
            {Array.from({ length: totalItems }).map((_, index) => renderGiftWidgetContent(index))}
        </div>
    );
};
